import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const InscripcionesData = {
    obtenerData: async () => {
        let url = url_json + "/inscripcion-data"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerDataFecha: async estado => {
        let url = url_json + "/inscripcion-data/fechas"
        let body = {
            estado
        };
        let request = {
            method:'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerDataRango: async estado => {
        let url = url_json + "/inscripcion-data/rango-fechas"
        let body = {
            estado
        };
        let request = {
            method:'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    // params: archivado, licenciatura, estado, anio, cuatrimestre, buscar, pagina, limite (los vacíos no se mandan, salvo licenciatura '')
    listar: async params => {
        let query = new URLSearchParams(Object.entries(params).filter(([clave, valor]) => valor !== undefined && valor !== null && (valor !== '' || clave === 'licenciatura')));
        let url = url_json + "/inscripcion-data/lista?" + query;
        let request = {
            method: 'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    carpetas: async archivado => {
        let url = url_json + "/inscripcion-data/carpetas?archivado=" + archivado;
        let request = {
            method: 'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    // Solo los campos que cambian (estadoAlumno o archivado): no se reenvía la solicitud completa
    cambiarEstado: async (id, cambios) => {
        let url = url_json + "/inscripcion-data/" + id;
        let request = {
            method: 'PATCH',
            body: JSON.stringify(cambios),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (!response.ok) {
            Swal.fire('Error!', 'No se pudo actualizar la solicitud: ' + res.message, 'error');
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerUnData: async id => {
        let url = url_json + "/inscripcion-data/" + id
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarData: async (data, id) => {
        return Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea modificar el campo?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let url = url_json + "/inscripcion-data/" + id;

                let body = {
                    archivado: data.archivado,
                    archivo: data.archivo,
                    celular: data.celular,
                    ciudad: data.ciudad,
                    colonia: data.colonia,
                    cuatrimestre: data.cuatrimestre,
                    domicilio: data.domicilio,
                    email: data.email,
                    empresa: data.empresa,
                    estadoAlumno: data.estadoAlumno,
                    fecha: data.fecha,
                    licenciatura: data.licenciatura,
                    nombre: data.nombre,
                    nombreMadre: data.nombreMadre,
                    nombrePadre: data.nombrePadre,
                    pago: data.pago,
                    telefonoEmergencia: data.telefonoEmergencia,
                    telefonoEmpresa: data.telefonoEmpresa
                };
                let request = {
                    method: 'PATCH',
                    body: JSON.stringify(body),
                    headers: authHeader()
                }

                let response = await fetch(url, request);
                let res = await response.json();
                if (response.ok) {
                    Swal.fire(
                        'Modificación exitosa!',
                        'Campo modificado correctamente' ,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo modificar el campo' ,
                        'error'
                    )
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Modificación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        });
    },
    archivarVarios: async ids => {
        const result = await Swal.fire({
            icon: "question",
            title: `¿Archivar ${ids.length} solicitud${ids.length === 1 ? '' : 'es'} atendida${ids.length === 1 ? '' : 's'}?`,
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'Cancelar',
        });
        if (!result.isConfirmed) return;

        let url = url_json + "/inscripcion-data/archivar";
        let request = {
            method: 'PATCH',
            body: JSON.stringify({ ids }),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            const { solicitados, archivados } = res.data;
            Swal.fire(
                'Archivado exitoso!',
                archivados < solicitados
                    ? `Se archivaron ${archivados} de ${solicitados}. Las demas ya no estaban atendidas o ya estaban archivadas.`
                    : `Se archivaron ${archivados} de ${solicitados}`,
                archivados < solicitados ? 'warning' : 'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudieron archivar las solicitudes',
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    },
    obtenerDataArchivo: async estado => {
        let url = url_json + "/inscripcion-data/estado"
        let body = {
            estado
        };
        let request = {
            method:'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerDataArchivoRango: async body => {
        let url = url_json + "/inscripcion-data/rango-fechas";
        let request = {
            method:'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
}

export default InscripcionesData;
